import { render } from "./AmenityPriceField.vue?vue&type=template&id=1f5b721e"
import script from "./AmenityPriceField.vue?vue&type=script&lang=js"
export * from "./AmenityPriceField.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__